module.exports = __webpack_public_path__ + "static/media/BannerRegistroES.7c05b6a8.jpg";